import React, { useCallback } from "react";
import { Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAppDispatch } from "@hooks";
import { logout } from "@slices";

export const LogoutButton = () => {
    const dispatch = useAppDispatch();

    const handleLogout = useCallback(() => {
        dispatch(logout());
    }, [dispatch]);

    return (
        <Button
            color="inherit"
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
            aria-label="Logout"
        >
            Logout
        </Button>
    );
};
